<template>
  <div class="outer">
    <hr />
    <b-container>
      <h2>Cast Your Vote</h2>
      <div class="vote-desc">
        Every facebook user can vote for there favorte display in 5 different categories (Musical, Static, Indiana, Kentucky, and Ohio).
        This display is eligible for
        <span
          v-bind:class="isKY"
        >Kentucky</span>
        <span v-bind:class="isOH">Ohio</span>
        <span v-bind:class="isIN">Indiana</span>
        and
        <span v-bind:class="isMusical">Musical</span>
        <span v-bind:class="isStatic">Static</span>
        .
      </div>
      <div
        class="alert alert-info"
        role="alert"
        v-if="getFbId === -1"
      >Want to vote for this Display? You'll need to log into Facebook first.</div>
      <div style="margin-top:1em" v-else>
        <div class="row">
          <div class="col-6">
            <b>Vote Button</b>
          </div>
          <div class="col-6">
            <b>Current Vote</b>
          </div>
        </div>
        <div class="row" v-bind:class="isOH">
          <div class="col-6">
            <button @click="localVote('OH')">Cast Ohio Vote</button>
          </div>
          <div class="col-6">
            <span class="current-vote">{{getVotedDisplays.OH.title}}</span>
          </div>
        </div>
        <div class="row" v-bind:class="isKY">
          <div class="col-6">
            <button @click="localVote('KY')">Cast Kentucky Vote</button>
          </div>
          <div class="col-6">
            <span class="current-vote">{{getVotedDisplays.KY.title}}</span>
          </div>
        </div>
        <div class="row" v-bind:class="isIN">
          <div class="col-6">
            <button @click="localVote('IN')">Cast Indiana Vote</button>
          </div>
          <div class="col-6">
            <span class="current-vote">{{getVotedDisplays.IN.title}}</span>
          </div>
        </div>
        <div class="row" v-bind:class="isMusical">
          <div class="col-6">
            <button @click="localVote('musical')">Cast Musical Vote</button>
          </div>
          <div class="col-6">
            <span class="current-vote">{{getVotedDisplays.musical.title}}</span>
          </div>
        </div>
        <div class="row" v-bind:class="isStatic">
          <div class="col-6">
            <button @click="localVote('static')">Cast Static Vote</button>
          </div>
          <div class="col-6">
            <span class="current-vote">{{getVotedDisplays.static.title}}</span>
          </div>
        </div>
      </div>
      <div class="facebook">
        <Facebook />
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Facebook from "./Facebook.vue";

export default {
  name: "VoteFor",
  components: {
    Facebook
  },
  methods: {
    ...mapActions(["fetchState", "addVote"]),
    localVote(type) {
      // Analytics?
      let id = this.getActive[0].displayid;
      this.addVote({ type: type, id: id });
    }
  },
  computed: {
    ...mapGetters([
      "getFbId",
      "getVotedDisplays",
      "getAvaiableVotes",
      "getActive",
      "votedForCurrent"
    ]),
    isKY() {
      return {
        eligible: true,
        "d-none": this.getActive[0].state != "KY"
      };
    },
    isOH() {
      return {
        eligible: true,
        "d-none": this.getActive[0].state != "OH"
      };
    },
    isIN() {
      return {
        eligible: true,
        "d-none": this.getActive[0].state != "IN"
      };
    },
    isMusical() {
      return {
        eligible: true,
        "d-none": !this.getActive[0].isMusical
      };
    },
    isStatic() {
      return {
        eligible: true,
        "d-none": this.getActive[0].isMusical
      };
    }
  }
};
</script>
<style scoped>
h2 {
  color: darkred;
}
.vote-desc {
  text-align: left;
}
.eligible {
  color: green;
}
.facebook {
  padding-bottom: 1em;
  margin-top: 1em;
}
</style>
